export default "__VITE_ASSET__248c2666__"